import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

import ReactStars from "react-rating-stars-component";

import "./Reviews.css";

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://young-hamlet-12954.herokuapp.com/reviews")
      .then((res) => res.json())
      .then((data) => {
        setReviews(data);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Spinner animation="border" variant="danger" className="text-center" />
    );
  }

  return (
    <div className="reviews">
      <div className="container pt-5 pb-5">
        <h2 className="text-center">What Our Customers Say</h2>

        <div className="row g-5">
          {reviews.map((review, index) => (
            <React.Fragment key={index}>
              <div className="col-12 col-md-6 review-card ">
                <div className="card h-100 " style={{ maxWidth: "570px" }}>
                  <div className="d-md-flex justify-content-md-between p-4 pb-0">
                    <div className="d-flex">
                      <div className="">
                        <img
                          src="https://i.ibb.co/47xsQnf/Pngtree-female-user-vector-avatar-icon-4005063.png"
                          alt=""
                          width="70"
                          height="70"
                        />
                      </div>
                      <div className="pt-1">
                        <h6 className="fw-bold">{review.name}</h6>
                        <p className="text-muted">{review.email}</p>
                      </div>
                    </div>
                    <div className="rating">
                      <ReactStars
                        count={5}
                        size={24}
                        value={review.rating}
                        isHalf={true}
                        edit={false}
                        emptyIcon={<i className="far fa-star"></i>}
                        halfIcon={<i className="fa fa-star-half-alt"></i>}
                        filledIcon={<i className="fa fa-star"></i>}
                        activeColor="#ffd700"
                      />
                    </div>
                  </div>
                  <div className="card-body">
                    <p className="card-text">{review.review}</p>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reviews;
